'use strict';

import axios from 'axios';
import { createVueInstance } from './helpers/vue-instance';
import { showUserError, initializeModals } from './_utils';
import { toggleSubscription } from './_vue-functions';

let api = window.llbPortal;

let loadMoreContainer = '.load-more-container';

createVueInstance({
	el: '[data-init="downloadcenter"]',
	delimiters: ['$({', '})'],
	data: {
		entries: [],
		tags: [],
		newTags: [],
		query: null,
		pageNumber: 1 // BE is already displaying page 0
	},
	methods: {
		getTags: function() {
			// get active tags from the url
			// some.url/tags/tag1,tag2,tag3?param=lorem => [tag1, tag2, tag3]
			this.tags = window.location.href.match(/\/tags\/([^?#\/]*)/);

			if (this.tags) {
				this.tags = this.tags[1].split(',');
				this.newTags = this.newTags.concat(this.tags); // duplicate tags array for further manipulation
			}
		},

		getQuery: function() {
			// get active 'query' parameter from the url
			this.query = window.location.search.split('query=')[1] || null;

			if (this.query) {
				this.query = this.query.split('&')[0];
			}
		},

		getEntries: function(loadMore = false) {
			let link;

			if (loadMore) { // load more items dynamically via API call
				link = `${api.apiUrls.downloadcenterApiGetList}/${this.pageNumber}`;

				if (this.newTags && this.query) {
					link = `${link}?tags=${this.newTags.toString()}&query=${this.query}`;
				} else if (this.newTags) {
					link = `${link}?tags=${this.newTags.toString()}`;
				} else if (this.query) {
					link = `${link}?query=${this.query}`;
				}

				axios.get(link).then((response) => {
					const loadMoreNode = document.querySelector(loadMoreContainer);

					// hide the load more button when there are no more results coming
					if (response.data.isLastPage && loadMoreNode) {
						loadMoreNode.classList.add('hidden');
					} else if (!response.data.isLastPage && loadMoreNode && loadMoreNode.classList.contains('hidden')) {
						loadMoreNode.classList.remove('hidden');
					}

					this.entries = this.entries.concat(response.data.mediaItems);
					this.pageNumber++;

					initializeModals();
				}).catch((error) => {
					console.log(error);
					showUserError(error);
				});

			} else { // navigate to new url based on the currently used tags ('query' parameter is changed via form submit and doesn't have to be handled here)

				if ((this.newTags.length > 0) && this.tags) {
					window.location.pathname = window.location.pathname.replace('/tags/' + this.tags.toString(), '/tags/' + this.newTags.toString());
				} else if ((this.newTags.length > 0) && !this.tags) {
					window.location.pathname = window.location.pathname + '/tags/' + this.newTags.toString();
				} else if ((this.newTags.length === 0) && this.tags) {
					window.location.pathname = window.location.pathname.replace('/tags/' + this.tags.toString(), '');
				}

			}
		},

		toggleTag: function(event) {
			let tag = event.currentTarget,
				tagName = tag.dataset.tagUrlName;

			if (this.newTags.indexOf(tagName) === -1) {
				this.newTags.push(tagName);
				tag.classList.remove('tags__tag--inactive');
			} else {
				this.newTags = this.newTags.filter(function(item) {
					return item !== tagName;
				});

				tag.classList.add('tags__tag--inactive');
			}
		},

		removeTag: function(event) {
			let tag = event.currentTarget,
				tagName = tag.dataset.tagUrlName;

			if (this.newTags.indexOf(tagName) !== -1) {
				this.newTags = this.newTags.filter(function(item) {
					return item !== tagName;
				});

				tag.classList.add('tags__tag--inactive');
			}

			this.getEntries(false);
		},

		decideActionWatchList: toggleSubscription
	},
	mounted: function() {
		this.getTags();
		this.getQuery();
	}
});
